module.exports = __webpack_public_path__ + "img/iphone_Action.efb20889.png";